/**
 * UI state for Settings › WhatsApp Business.
 * @param {object|null|undefined} whatsapp
 * @returns {'not_connected'|'syncing'|'connected'|'disconnected'}
 */
export function getWhatsappUiState(whatsapp) {
  if (!whatsapp) {
    return 'not_connected';
  }
  const { mode, status } = whatsapp;
  if (mode === 'none' || status === 'not_connected') {
    return 'not_connected';
  }
  if (status === 'syncing' || status === 'pending') {
    return 'syncing';
  }
  if (status === 'disconnected' || status === 'error') {
    return 'disconnected';
  }
  if (status === 'active') {
    return 'connected';
  }
  return 'not_connected';
}

export default getWhatsappUiState;
